import type {TicketingOrdersListLazyData, TicketingRsvpStats, TicketingStats} from '@Components/event-ticketing/event-ticketing.types';
import type {EventDonationsState} from './event-donations.types';

/**
 * The donations list a search maps to: the cached unfiltered list when there is no search, else the searched list.
 * Callers pass the live search or a request's own, so an in-flight page lands in the list it was fetched for.
 */
export const getActiveDonationsList = (state: EventDonationsState, search: string): TicketingOrdersListLazyData => {
  return search === '' ? state.defaultDonations : state.filteredDonations;
};

/**
 * Whether the event took donations and every one of them went back (refunded, or returned with a cancelled
 * registration) — the Donations tab then says so instead of "No donations yet". The held-only figures read 0 either
 * way, so this checks the received gross, which keeps returned donations: the earnings breakdown's Donation row on a
 * paid event, the donation money on an RSVP / free one.
 */
export const haveAllDonationsGoneBack = (stats: TicketingStats | TicketingRsvpStats): boolean => {
  const donationsReceived = 'salesByMethod' in stats ? stats.salesByMethod.donation : stats.donationMoney.received;
  return donationsReceived > 0 && stats.donationCount === 0;
};
